import zhLocale from 'element-ui/lib/locale/lang/zh-TW'
const tw = {
	...zhLocale,
	model:{
		messagemin:'請確認完成基本信息錄入',
	},
	header: {
		p1: "親愛的客戶:",
		p2: "如有任何疑問，請於辦公時間內致電。",
		p3: "客戶服務專線:",
		p3_ph: "(852) 3971 6988",
		p4: "免費內地熱線:",
		p4_ph: "4001 206 046",
		p5: "辦公時間:上午9:00 - 下午6:00",
		p6: "星期六、星期日及香港公眾假期休息",
		p7: "華亞金融集團官方微信",
		p8: "華亞金融集團官方客服"
	},
	allpage: {
		qtxbtxadd: "請輸入住宅地址",
		qtxbtx: "請填寫必填項",
		ts30mintj: "請於60分鐘內填寫並提交開戶申請，逾時將不會保留已填寫的開戶信息。",
		queding: "確   認",
		tishi: "提   示",
		syserr: "服務器異常！",
		pleasechecknet: "請求失敗，請檢查網絡！",
		wrongfile: "上載錯誤，文檔必需使用 PNG / JPG / JPEG 格式",
		filesizeeror: "上載失敗, 照片不可超過 2M",
		xiuxintime: "休息時間不可選！",
		yuyuesize: " 預約人數已滿請選擇其他時間段",
		kfcx: "客服查詢"
	},
	tabbar: {
		jbxx: "基本信息",
		sgzk: "受僱狀況",
		cwzk: "財政狀況",
		khsm: "客戶聲明",
		fxpg: "風險評估",
		wjsc: "上載文件",
		ktzh: "開通帳戶",
		yykh: "預約開戶"
	},
	khxy: {
		khzhxy: "客戶綜合協議",
		tygxy: "同意該協議",
		loading: "正在努力為您加載客戶協議"
	},
	login: {
		later:'後獲取',
		copyright:'©2025 華亞金融集團版權所有',
		zysx:'注意事項',
		cjwt:'常見問題',
		xgtk:'相關條款',
		jszy:'技術支援',
		khjx:'開戶教學',
		xgzl:'相關資料',
		leave:'離開',
		klzh:'開立帳戶',
		khzl:'客戶資料',
		ywzk:'工作/業務狀況',
		tzgk:'財政及投資概況',
		khsm:'客戶聲明及簽署',
		fxpg:'風險評估',
		wskh:'網上開戶',
		fanhui:'返回',
		chongzhi:'重置',
		cucun:'儲存',
		jixu:'繼續',
		step:" 步驟",
		email:'電郵',
		verificationcode:'驗證碼',
		fullname:'姓名',
		telephone:'電話號碼',
		plaletelephone:'請輸入電話號碼',
		plaletelephoneweb:'請輸入電話號碼',
		plaletelephones:'請輸入電話號碼',
		submit:'提交',
		submits:'提 交',
		khname: '請完成 ( 紅色提示 / 紅框 ) 部分',
		khtitle: '開立證券交易帳戶',
		khbutton: "立即開戶",
		yanzhengma: "獲取驗證碼",
		phoneinput: "請輸入手機號碼",
		vcodeinput: "請輸入驗證碼",
		jiaoxue: "線上開戶教學",
		khzb: "開戶準備",
		idcard: "身份證",
		pass: "通行證/護照",
		bankcard: "銀行卡",
		lxwm: "cs@qmis.com.hk",
		lxwm1: "聯絡我們",
		ybcx: "客戶服務熱線",
        jyrx: "交易服務熱線",
        mfndzx: "內地免費服務熱線",
        dy: "電郵地址",
		aftersecond: "s後獲取",
		regetcode: "重新獲取",
		quhaop: "請選擇區號！",
		phoneinputp: "請輸入手機號！",
		errormsg: "服務器异常！",
		failmsg: "請求失敗,請檢查網絡！",
		vscodep: "請輸入驗證碼！",
		success: "登入成功",
		failmsgw: "阿歐，出錯了！",
		tongyip: "先閱讀並同意開戶協定後重試！",
		yjydbty: "已經閱讀並且同意",
		khxyhz: "開戶協議",
		yuedukhxyhz: "閱讀開戶協議",
		zgdl: "中國",
		zgxg: "中國香港",
		zgam: "中國澳門",
		adly: "澳大利亞",
		jnd: "加拿大",
		mlxy: "馬來西亞",
		mg: "美國",
		xjp: "新加坡",
		xxl: "新西蘭",
		yg: "英國",
		qt: "其他",
		emailinput: "請輸入電郵地址",
		khtext1:'開戶程序簡易快捷：',
		khtext2:'輸入手機號碼',
		khtext3:'獲取並輸入驗證碼',
		khtext4:'閱讀並同意協議書',
		khtext5:'上載個人資料及文件',
		khtext6:'完成問卷',
		khtext7:'選擇開戶方式',
		khtext8:'背景調查獲批後開戶程序完成',
		khtext9:'開戶申請',
		khtext10:'手機號碼',
		khtext11:'電郵地址',
		khtext12:'請輸入驗證碼',

	},
	khlx: {
		// wxz
		grzh:"個人帳戶",
		sczj:"上載證件",
		khqd:"開戶渠道",
		qsrkhqd1:"請選擇開戶渠道",
		qsrkhqd:"請輸入開戶渠道",
		wjyy:"未經預約",
		qyzj:"親友轉介",
		hlw:"互聯網、報章、雜誌",
		ktdzjy: "電子交易",
        needktdzjy: "需要電子交易服務",
        noktdzjy: "不需要電子交易服務",
		xgjmsfz: "香港居民身份證",
		gnrssfz: "國內人士身份證",
		hzhfxgsfz: "護照或非香港居民身份證",
		sfzm:'身份證明',
		qxzsfzm:'請選擇身份證明',
		zp2M:'每張照片不可超過2M',
		sfzzzm:'身份證正面',
		sfzzfm:'身份證背面',
		xgzm:' 往來港澳通行證正面',
		xgfm:' 往來港澳通行證背面',
		hz:'護照',
		jscx:'接收促銷',
		bjscx:'不接收促銷',
		SMS:'短信',
		Phone_dh:'電話',
		Email_yx:'電郵',
		Mail_yj:'郵寄',
		// wxz
		khlx: "開戶類型",
		lxxz: "類型選擇",
		gr: "個人",
		zhzl: "帳戶類型",
		xjzh: "證券現金帳戶",
		dydz: "電郵地址",
		dydzinput: "請輸入電郵地址",
		errordydzinput: "請輸入有效的電郵地址",
		shi: "開啟",
		fou: "關閉",
		qscselfphoto: "請上載自拍圖片",
		picjzz: "加載中",
		choose1: "華亞證券及/或其聯屬公司可能會使用客戶的個人資料作直接促銷用途。",
		choose4: "請於下列相關方格內填上(「✔️」)號，表明閣下對華亞證券透過以下任何途徑將閣下之資料用於華亞證券「私隱政策」有關《個人資料(私隱)條例》(「條例」) (香港法例第486章)中載列之直接促銷所作之選擇 :",
		choose5: "以上表示客戶同意並確認客戶現欲收取華亞證券及/或其聯屬公司的直接促銷或/及資訊的選擇，並取代客戶於本手機交易平台「帳戶開立申請」前向華亞證券傳達的任何選擇。",
		choose6: "客戶明白可以隨時通過華亞證券手機交易平台及其它指定渠道要求更改有關設定。",
		xiayibu: "下一步"
	},
	jbxx: {
		zzyq1:'自置',
		zzyq2:'與家人同住',
		zzyq3:'按揭',
		zzyq4:'租用',
		dy1:'電郵 至 指定電郵地址',
		dy2:'郵遞 至 通訊地址',
		dy3:'郵遞 至 住宅地址',
		dy4:'*郵寄月結單/通知書每份港幣20元',
		tzfs:'通訊方式',
		jdfs:'結單方式',
		qxzjdfs:'請選擇結單方式',
		sm1:'住宅地址及/或通訊地址證明 (副本)',
		sm2:'- 文件須於此開立證券交易帳戶簽署日期之前三個月內所發出',
		sm3:'- 例如：銀行結單、公用事業繳費單 (須載有相關戶口持有人名稱及地址)，並須列印發出單據公司名稱及發單日期',
		sm4:'3. 水／電／煤氣收費單',
		swbhyy:'請輸入不能取得稅務編號的原因',
		tzzl:'通訊資料',
		zzdzbt:'與住宅地址不同時填寫',
		zzdz_radio1:'與住宅地址相同',
		zzdz_radio2:'與住宅地址不同',
		yyxz:"語言選擇",
		qxzyyxz:"請選擇結單語言",
		ddzm: "地址證明",
		qscddzm: "請上載地址證明文件",
		yscddzm: "已上載地址證明文件",
		zzyq: "住宅業權",
		qsrzzyq1: "請選擇住宅業權",
		qsrzzyq: "請輸入住宅業權",
		address: "通訊地址",
		addressinput: "請輸入通訊地址（不接受郵政信箱）",
		grxinx: "個人信息",
		zwxm: "中文名稱",
		ywxm: "英文名稱",
		qshurzhongwenm: "請輸入中文名稱",
		qshruyingwenming: "請輸入英文名稱",
		cal: "稱謂",
		xiansheng: "先生",
		nvshi: "小姐",
		taitai: "太太",
		qxzchenghu: "請選擇稱呼",
		birth: "出生日期",
		birthplace: "出生地點",
		qsrbirthplace: "請輸入出生地點",
		qfdd: "簽發地點",
		qsrqfdd: "請輸入簽發地點",
		nationality: "國籍/公民身份",
		qsrnationality: " 請輸入國籍/公民身份",
		qsrnationality1: " 請選擇國籍/公民身份",
		jiaoyuchengdu: "最高學歷",
		qxzjycd: "請選擇最高學歷",
		jiaoyuchengdushi: "您的教育程度是？",
		xiaoxuehuoyixia: "小學",
		zhongxuechengdu: "中學",
		dazhuanchengdu: "大專",
		ftzw: '繁體中文',
		jtzw: '简体中文',
		yingwen: 'English',
		daxuehuoyishang: "大學或以上",
		fjsm1: "客戶同伴/多一位華亞證券員工安排（並不適用於客戶年齡爲65歲或以下，或教育程度爲小學六年級以上), 由於本人/(吾等) 是： ",
		zhangzhe: "長者（66歲或以上）",
		jiaoyuchengduxiaoliu: "教育程度 ( 小學六年級或以下 )",
		khtbap: "客戶同伴安排",
		fjsm2: "本人/(吾等)確認並明白本人/(吾等)有權攜同同伴在華亞證券有限公司（下稱「華亞證券」）( 證監會中央編號 : ARK249 )開立證券交易帳戶之過程中陪同本人/(吾等)瞭解「華亞證券交易帳戶協議書」、內附第四部份「風險披露聲明」所載的內容及所需收取費用與收費。",
		lable3: "本人/(吾等) 現攜同同伴，同伴名稱:",
		fjsm3: "（下稱「同伴」與本人/(吾等)之關係爲",
		fjsm4: "），在此開戶過程中陪同本人/(吾等)，而同伴現時之年齡介乎18至65歲、擁有中學教育程度或以上、在講解過程中使用能夠溝通的語言並協助本人/(吾等)明白所有相關文件所需的知識及經驗。",
		fjsm5: "本人/(吾等)特此確認華亞曾強烈提議本人/(吾等) 攜同同伴出席本次會晤以完全明白所有相關文件的內容及證券投資所涉及的風險。惟本人/(吾等)確認本人/(吾等)在毋須同伴參與的情況下亦有足夠能力明白以上提及有關本人/(吾等)申請開立帳戶事宜。",
		lable4: "多一位員工安排（必須在華亞證券的香港辦事處進行）",
		fjsm8: "本人/(吾等)特此確認並明白本人/(吾等)有權利選擇多一位華亞證券之持牌中介人辦理此開立交易帳戶過程以增加對本人/(吾等)的保障。",
		fjsm6: "本人/(吾等)希望多一位華亞證券之持牌中介人辦理此開戶過程，並確認申請開立帳戶過程如常進行。（華亞證券之持牌中介人名稱:",
		zhiwei: "工作職位",
		fjsm7: "儘管本人/(吾等)有權選擇，但本人/(吾等)確認本人/(吾等)毋需多一位華亞證券之持牌中介人辦理此開立交易帳戶過程。",
		queding: "確認",
		quxiao: "取消",
		qingshurutbxm: "請輸入同伴姓名",
		qingtianxie: "請填寫",
		tanxiefjsm: "請填寫附加聲明",
		fjsm: "請填寫附加聲明",
		sfxx: "身份信息",
		sfzmwjzl: "身份信息",
		qxzsfzmwjzl: "請選擇身份證明文件種類",
		xgjmsfz: "香港居民身份證",
		gnrssfz: "國內人士身份證",
		hzhfxgsfz: "護照或非香港居民身份證",
		sfz: "身份證號碼",
		huzhao: "護照號碼",
		gj: "國籍",
		swbh: "稅務編號",
		bsdq: "報稅地區",
		rmyswbh: "如沒有提供稅務編號：",
		causeA: "理由A-帳戶持有人的居留司法管轄區並沒有向其居民發出稅務編號。",
		causeB: "理由B-帳戶持有人不能取得稅務編號。如選這一理由，解釋帳戶持有人不能取得稅務編號的原因。",
		causeC: "理由C-帳戶持有人毋須提供稅務編號。居留司法管轄區的主管機關不需要帳戶持有人披露稅務編號。",
		qxzwftgswbhdly: "請選擇無法提供稅務編號的理由",
		chooseB: "如果選取理由B，請解釋帳戶持有人不能取得稅務編號的原因",
		zzdz: "通訊地址(中文)",
		zzdz1: "通訊地址(英文)",
		djwl: "單據往來",
		djyyxz: "單據語言",
		danjuways: "選擇下列一種方式發送成交單據正本（買賣確認）及對帳單（如客戶選用郵寄方式，將每月收取紙張結單及行政費10美金）",
		dydz: "電郵地址",
		bscdz: "住宅地址",
		yhzh: "香港銀行帳戶資料",
		yhmc: "銀行名稱",
		zhmc: "帳戶名稱",
		zhhm: "帳戶號碼",
		fz1: "備註：收款帳戶名稱必須與交易帳戶名稱相同，否則開戶將不被接納。",
		qsrsfzhm: "請輸入身份證號碼",
		qsrhzhm: "請輸入護照號碼",
		qsrgj: "請輸入國籍",
		qsrswbh: "請輸入稅務編號",
		qsrbsdq: "請輸入報稅地區",
		qsrly: "請輸入不能取得稅務編號的理由",
		qsrzjdz: "請輸入通訊地址(中文) (不接受郵政信箱)",
		qsrzjdz1: "請輸入通訊地址(英文) (不接受郵政信箱)",
		qxzdjyy: "請選擇結單語言",
		qxzdjwldz: "請選擇單據往來地址",
		qsryhmc: "請輸入香港銀行名稱",
		qsrzhmc: "請輸入帳戶名稱",
		qsrzhhm: "請輸入帳戶號碼",
		qxuanzeriqi: "請選擇出生日期",
		swbhjstitle: "稅務編號說明",
		swbhjs1: "香港稅務居民/中國稅務居民，稅務編號是香港居民身份證號碼/中國居民身份證號碼。",
		swbhjs2: "香港/中國以外的稅務居民，則需填寫稅務管轄地區及稅務編號。如未能提供稅務編號，必須填寫合適理由。",
		swbhj1:'香港身份證號碼輸入所有英文字母及括弧內數字（無需輸入括弧符號）例如：A1234567。',
		swbhj2:'內地身份證號碼輸入所有數字及英文字母。',
		swbhj3:'護照或非香港居民身份證號碼輸入所有數字及英文字母（無需輸入符號）例如：AB123Y。',
		xiayibu: "下一步"
	},
	sgzk: {
		nq_1:' 年期',
		year_1:' 年',
		year_2:' 年數 ',
		month_1:' 月',
		jyzk:'就業狀況',
		gzmc:'僱主名稱',
		qsrgzmc:'請輸入公司名稱',
		gsdz:'公司地址',
		qsrgsdz:'請輸入公司地址',
		hy:'行業',
		qsrhy:'請輸入行業',
		zc:'職稱',
		qsrzc:'請輸入職稱',
		fwnz:'服務年資',
		qsrfwnz:'請輸入服務年資',
		fwyz:'服務月資',
		qsrfwyz:'請輸入服務月資',

		sglx: "受僱類型",
		sg: "受僱",
		qz: "全職",
		jz: "兼職",
		zg: "自僱",
		tx: "退休",
		qt: "其他",
		gsmc: "公司名稱",
		gsxz: "業務性質",
		guzhu: "請輸入公司名稱",
		qsrgz: "請輸入僱主",
		ywxz: "請選擇或輸入業務性質",
		zhiwei: "職位",
		xuzzhiwei: "請選擇或輸入職位",
		xuzzhiweie: "請輸入職位",
		gujiahuodiqu: "國家或地區",
		qingxuangjhdq: "請選擇或輸入國家或地區",
		qsrsgsj: "請選擇受僱時間",
		qsrzgzk: "請輸入自僱狀況",
		qsrqtzk: "請輸入其他狀況",
		xiayibu: "下一步",
		ywxz1: "汽車",
		ywxz2: "金融及經濟自營商",
		ywxz3: "政府及公關",
		ywxz4: "農業、林業及漁業",
		ywxz5: "採礦及採石",
		ywxz6: "製造業",
		ywxz7: "電力及燃氣供應",
		ywxz8: "自來水、污水處理及廢棄物管理",
		ywxz9: "建造業",
		ywxz10: "進出口貿易、批發及零售業",
		ywxz11: "運輸、倉庫、郵政及速遞",
		ywxz12: "酒店及飲食業",
		ywxz13: "資訊及通訊",
		ywxz14: "地產業",
		ywxz15: "法律及會計",
		ywxz16: "廣告及市場",
		ywxz17: "行政及支援服務",
		ywxz18: "教育",
		ywxz19: "醫療",
		ywxz20: "服務活動",
		ywxz21: "",
        ywxz22: "",
        ywxz23: "",
        ywxz24: "",
		xuzzhiwei1: "見習生",
		xuzzhiwei2: "助理",
		xuzzhiwei3: "文員",
		xuzzhiwei4: "經理",
		xuzzhiwei5: "行政人員",
		xuzzhiwei6: "管理人員",
		xuzzhiwei7: "董事",
		// xuzzhiwei10: "部門經理",
		// xuzzhiwei11: "區域經理",
		qingxuangjhdq1: "中國",
		qingxuangjhdq2: "中國香港",
		qingxuangjhdq3: "中國澳門",
		qingxuangjhdq4: "馬來西亞",
		qingxuangjhdq5: "新加坡",
		qingxuangjhdq6: "澳洲",
		qingxuangjhdq7: "英國",
		qingxuangjhdq8: "美國",
		qingxuangjhdq9: "加拿大",
		qingxuangjhdq11: "紐西蘭",
		qingxuangjhdq10: "中國臺灣",
		sgsj: "受僱時間",
		qxztztime: "請選擇服務月資"
	},
	cwzk: {
		srly:"收入來源",
		qxzsrly:"請選擇收入來源",
		gz:"薪金 / 工資",
		cx:"儲蓄 / 家庭 ",
		zj:"租金",
		gx:"股息 / 利息",
		ywtl:"業務溢利",
		mnzsr:"每年總收入(港幣)",
		qxzmnzsr:"請選擇每年總收入",
		wsr:"沒有收入",
		zclb:"資產類別",
		qxzzclb:"請選擇資產類別",
		xj:"現金 / 銀行存款",
		fdc:"房地產",
		gsgf:"公司股份",
		yc:"遺產",
		sszq:"外幣 / 貴金屬買賣",
		jj:"基金",
		zq:"債券 / 債權證",
		whzj:"外匯資金",
		zzcjz:"總資產淨值(港幣)",
		qxzzzcjz:"請選擇總資產淨值",
		tzgk:"投資概況",
		tzmb:"投資目標",
		qxztzmb:"請選擇投資目標",
		gxsy:'股息收益',
		zbzz:'資本增值',
		zxtz:'長線投資',
		dxtz:'短線買賣',
		dctz:'對沖投資',
		fxcsnl:'風險承受能力',
		qxzfxcsnl:'請選擇風險承受能力',
		dfx:'低風險',
		zfx:'中風險',
		gfx:'高風險',
		tzlxjjy:'投資類型及經驗 (可選多於一項)',
		kdxyx:'可選多於一項',
		cbbc:'證券 / 交易所買賣基金',
		etf:'債券',
		futures:'互惠基金 / 單位信託',
		commodities :'衍生性金融商品',
		trust:'定息債劵',
		forex:'結構性 / 槓桿產品',
		reits:'房地產投資信託基金',
		yscp:'衍生產品知識',
		yscp_1:'請問客戶對「衍生及結構性投資產品」有沒有足夠認識？',
		yscp_2:'請問客戶從那些途徑認識「衍生及結構性投資產品」？',
		yscp_3:'接受「衍生及結構性投資產品」培訓或修讀相關課程',
		yscp_4:'現時的工作 或/及 以往的工作經驗與「衍生及結構性投資產品」有關',
		yscp_5:'客戶相關投資經驗（於最近三年、最少有五次或以上之產品交易）',
		you:'有',
		noyou:'没有',

		cwzk: "財政狀況",
		mnsr: "每年收入（HKD）",
		zcjz: "資產淨值（HKD）",
		zjly: "資金來源",
		chuxu: "儲蓄",
		jiating: "家庭",
		yyyl: "營業溢利",
		zjsr: "租金收入",
		daikuan: "貸款",
		qita: "其他",
		qsrqita: "請輸入其他",
		qtzi: '其他', //資金來源
		zjlyother: "請填寫其他資金來源",
		tzmb: "投資目標",
		tzmbsm: "閣下在下方的選擇將決定能獲準交易的產品，請選取適用選項",
		touji: "投機",
		zhuanqushouru: "賺取收入",
		duichong: "對沖",
		tzmbother: "請填寫其他投資目標",
		tzmbotherww: "其他", //投資目標
		planother: "其他", //投資計劃
		inputplanother: "請填寫其他投資計劃",
		tzjh: "投資計劃",
		shijianduoxuan: "時間",
		duanqi: "短期",
		zhongqi: "中期",
		changqi: "長期",
		timeother: "請輸入時間",
		tzjy: "投資經驗",
		touzijingyanxuanze: "請選擇投資經驗",
		years: "投資年數",
		year: "年",
		over10year: "大於10年",
		qhqq: "期貨或期權",
		jijin: "基金",
		zhaiquan: "債券",
		wtzjy: "無投資經驗",
		tzjyother: "其他", //投資經驗
		qxztztime: "請選擇投資年數",
		qxzmnsr: "請選擇每年收入",
		qxzzcjz: "請選擇資產淨值",
		qxzzjly: "請選擇資金來源",
		qsrqtzjly: "請填寫其他資金來源",
		qxztzmb: "請選擇投資目標",
		qsrqttzmb: "請填寫其他投資目標",
		qxztzjh: "請選擇投資計劃",
		qsrqttzjh: "請填寫其他投資計劃",
		qxztzjy: "請選擇投資經驗",
		qsrqttzjy: "請填寫其他投資經驗",
		xiayibu: "下一步"
	},
	khsm: {
		// wxz
		wenti_1_1:'否（請提供此帳戶之最終實益擁有人資料）',
		wenti_1_2:'最終實益擁有人名稱',
		wenti_1_3:'請輸入最終實益擁有人名稱',

		wenti_3_1:'持牌法團/註冊機構名稱',
		wenti_3_2:'職稱',
		wenti_3_3:'證監會中央編號',
		wenti_3_4:'聘任公司證監會中央編號',
		wenti_3_5:'請輸入持牌法團/註冊機構名稱',
		wenti_3_6:'請輸入職稱',
		wenti_3_7:'請輸入證監會中央編號',
		wenti_3_8:'請輸入聘任公司證監會中央編號',

		wenti_4_1:'董事/僱員名稱',
		wenti_4_2:'請輸入董事/僱員名稱',

		wenti_5_1:'配偶名稱',
		wenti_5_2:'請輸入配偶名稱',
		wenti_5_3:'帳戶號碼',
		wenti_5_4:'請輸入帳戶號碼',

		wenti_7_1:'帳戶名稱',
		wenti_7_2:'請輸入帳戶名稱',
		wenti_7_3:'帳戶類別',
		wenti_7_4:'請輸入帳戶類別',

		wenti_a_1:'A. 客戶需要詳細閱讀並同意有關華亞證券有限公司',
		wenti_a_2:'證券交易帳戶協議書',
		wenti_a_3:'風險披露聲明',
		wenti_a_4:'私隱政策',
		wenti_a_5:'稅務居民身份-自我證明表格（個人）',
		wenti_a_6:'香港投資者識別碼及場外證券交易聲明',
		wenti_a_7:'場外證券交易風險披露聲明',
		wenti_b:'B. 客戶知悉簽署樣式將作為本人於華亞證券有限公司之簽署記錄，日後華亞證券有限公司可憑客戶此簽署樣式執行各種交易指示，客戶需就該等指示負上全部責任。',
		qs:'簽署',
		khqs:'客戶簽署',
		wc:'確認',
		qc:'取消',

		wenti_1:'客戶是否此帳戶的「最終實益擁有人」？(即客戶是否為本身而並非為「第三者」運作此帳戶？）',
		wenti_2:'客戶 及/或 帳戶的最終實益擁有人，或其配偶、伴侶、子女或父母，或其子女的配偶或伴侶，或與其關係密切的人，是否擔任或曾擔任重要公職，包括 : 國家元首、政府首長、司法或軍事官員、國有企業高級行政人員或政要?',
		wenti_3:'客戶是否為根據《證券及期貨條例》(「證券條例」)下之註冊持牌法團 或《銀行業條例》(「銀行業條例」)下之註冊機構的僱員 ?(包括客戶現時為證監會註冊持牌代表 (「持牌代表」) 或 金管局註冊人員 (「註冊人員」) ）',
		wenti_4:'客戶、此帳戶的最終權益擁有人 及/或 就此帳戶進行交易的最終發出指令人士，與華亞證券或其聯屬公司之董事或僱員是否有任何關係 ?',
		wenti_5:'客戶無論是否單獨或與配偶共同控制任何華亞證券或其聯屬公司之公司帳戶百分之三十五 (35%)或以上的「投票權」 ?',
		wenti_6:'客戶的配偶是否為華亞證券或其聯屬公司之現金 及/或 保證金帳戶 ?',
		wenti_7:'客戶現時是否持有華亞證券或其聯屬公司之現金 及/或 保證金帳戶 ?',
		wenti_8:'客戶是否為「美國公民」（即持有「美國護照」）或就稅務目的而言的「美國居民」（即持有「美國綠卡」）?',
		wenti_9:'此帳戶是否由「授權人士」所操作 ?',
		wenti_9_1:'本人 / (吾等) 茲聲明對由本人 / (吾等) 獲授權人士或聲稱為獲授權人士所發出之任何指示（包括但不限於「口頭指示」或「書面指示」）承擔全部責任，並會就華亞證券因該等授權人士之任何行為、不作為或遺漏而引致的一切賠償、 損失、費用及開支向華亞證券作出全部彌償。',
		wenti_9_2:'當本人 / (吾等) 獲授權人士被正式授權後，即表示本人 / (吾等) 同意接受客戶授權中成為其授權人士，並同意承擔本人 / (吾等) 帳戶內之一切責任，亦須就華亞證券因授權人士 及/或 本人 / (吾等) 之任何行為、不作為或遺漏而引致的一切賠償、損失、費用及開支向華亞證券作出全部彌償。',
		sqrsmc:'獲授權人士名稱',
		sqrsid:'獲授權人士身份證 / 護照號碼',
		zhcyr:'帳戶持有人與獲授權人士之關係',
		sqrsphone:'獲授權人士聯絡電話號碼',
		qsrsqrsmc:'請輸入獲授權人士名稱',
		qsrsqrsid:'請輸入獲授權人士身份證 / 護照號碼',
		qsrzhcyr:'請輸入帳戶持有人與獲授權人士之關係',
		qsrsqrsphone:'請輸入獲授權人士聯絡電話號碼',
		// wxz
		messagea: '',
		messageb: '',
		messagec: '',
		messaged: '',
		khsm: "客戶聲明",
		qxzshf: "請選擇是或否",
		qscgzsmtytp: "請上載僱主書面同意書圖片",
		q1: "1.你是否此帳戶的最終實益擁有人？",
		shi: "是",
		foutigxx: "否（請申明以下資料）",
		mingcheng: "名稱",
		mingchenginput: "請輸入名稱",
		idcardpassnum: "身份證/護照號碼",
		idcardpassnuminput: "請輸入最終實益擁有人身份證/護照號碼",
		address: "通訊地址",
		addressinput: "請輸入最終受益人通訊地址（不接受郵政信箱）",
		q2: "2.你是否與華亞證券有限公司，其母公司或關聯公司之僱員代理人有親屬關係？",
		shitigxx: "是（請提供詳情）",
		fou: "否",
		guyudailirenname: "僱員代理人名稱",
		guyudailirennameinput: "請輸入僱員代理人名稱",
		guanxi: "關係",
		guanxiinput: "請輸入關係",
		q3: "3.你是否證監會註冊的持牌法團或註冊機構，或其他金融機構的僱員或代理人？",
		jigoumincheng: "機關機構名稱",
		jigouminchenginput: "請輸入機關機構名稱",
		guzhushumiantongyi: "閣下僱主的書面同意",
		shangchuantupian: "(上載圖片)",
		dianjixuanzetupian: "點擊選擇上載圖片",
		tupianmiss: "圖片走丟了",
		q4: "4.你是否上市公司之董事或股東，外國的公衆人物，例如政府高官、政黨領袖、宗教領袖等或其家人？",
		qingtigongxiangqing: "請提供詳情",
		q5: "5.你是否於華亞證券持有其他帳戶（包括有關人士持有之帳戶）？",
		accountnum: "帳戶號碼",
		accountnuminput: "請輸入帳戶號碼",
		accountname: "帳戶名稱",
		accountnameinput: "請輸入帳戶名稱",
		q6: "6.你是否美國公民或就稅務目的而言的居民（由於美國稅收申報要求，美國人帳戶需要特別審批）？",
		querenjiqianshu: "客戶確認及簽署",
		qianshu1: "載於本帳戶申請書（下稱「申請書」）的資料均屬真實及準確。閣下有責任在生效日開始的七（7）個曆日內通知華亞證券有關資料的任何重大改變。華亞證券有權隨時聯絡任何人，包括客戶的銀行、經紀或信貸機構，藉以核實本申請書上的任何資料。",
		qianshu1a: "本人謹此承諾並確認：",
		qianshu2: "A. 閣下確認已收到華亞證券以閣下選擇的語言（英文或中文）獲提供的",
		qianshu3: "，並已閱讀及明白協議書內之條款。",
		qianshu3a: "「（包括其附表、附錄及附件（如有）」",
		qianshu3b: "，而本人接納並同意受該等條款約束；",
		qianshu4: " 協議書",
		qianshu1b: "B. 閣下確認華亞證券已按照閣下選擇的語言 (英文或中文) 獲提供 ",
		qianshu1c: "已按照本人選擇的語言(英文或中文)獲提供",
		qianshu5: "風險披露聲明",
		qianshu2a: "（下稱「風險披露聲明」），並已獲邀閱讀載於協議書中的風險披露聲明、提出問題及徵求專業及獨立第三方之意見（若閣下有此意願）。",
		qianshu2b: "C. 閣下已閱讀載於協議書中有關",
		qianshu6: "「個人資料（私隱）條例」",
		qianshu2c: "的客戶通知，並明白及同意華亞證券私穩政策的條款。",
		qianshu61: "《交易帳戶協議書補充》",
		qianshu7: "D. 閣下知悉簽名樣式將作為本人於華亞證券之簽字記錄，日後華亞證券可憑閣下此簽名樣式執行各種交易指示，閣下需就該等指示負上全部責任。",
		qianshu8: "e.本人聲明及同意以下:",
		qianshu8a: "(i) 閣下填寫並簽署",
		qianshu9: "「W-8BEN」",
		qianshu10: "表格，此證明閣下並非為「美國公民」及作為美股交易之用途 (如適用);",
		qianshu10a: "(ii) 閣下填寫有關",
		qianshu11: "「個人稅務居民自我證明表格CRS-I (HK) ",
		qianshu12: "表格，即表示閣下同意遵守有關條款及聲明。",
		xiayibu: "下一步",
		nxyrzydxy: "閣下需要詳細閱讀並同意以下附件內有關華亞證券有限公司（下稱「華亞證券」）的「證券交易帳戶協議書」（下稱「協議書」）及私隱政策（下稱「私隱政策」）。",
		bryydbtykhxy: "本人 / ( 吾等 ) 已確認閱讀並同意以上條款及細則。",
		qydplease: "請閱讀附件內的客戶協議及私隱政策。"
	},
	fxpg: {
		fxpgtk:'請閱讀有關風險評估之聲明條款',
		qsrnr:'请输入内容',
		none:'無',
		dy_5:'≥ 5',
		xy_5:'< 5',
		none:'無',
		fxpg_title:'客戶請回答以下15條問題，並選擇最合適的答案。',
		wt_1:'請選擇客戶的「年齡組別」:',
		wt_2:'請簡述客戶的「最高學歷」:',
		wt_3:'請簡述客戶的「總淨資產」:',
		wt_4:'請簡述客戶在過往3年裡的「平均每年收入」:',
		wt_5:'請描述客戶的「收入來源」:',
		wt_6:'客戶有否預留任何資金或高流動性的資產 (備註：特別在發生任何未能預測的事件) 去應付「每月的家庭開支」?',
		wt_7:'請陳述客戶的「投資經驗」：',
		wt_8:'客戶將會分配「多少百分比」的「資產淨值」作為投資用途 ?',
		wt_9:'請簡述客戶對以下投資產品類別，在過去3年內的「投資經驗」:(備註：可選擇多於一項答案，如適用)',
		wt_10:'請問閣下對「衍生及結構性投資產品」有否足夠認識，這包括其本質及風險 ?',
		wt_11:'以下哪一項最能夠表達客戶的「主要投資目標」?',
		wt_12:'客戶對自己金融投資組合「每年波幅及潛在回報」一般來說可接受的風險承受程度是怎樣 ?',
		wt_13:'請簡述客戶期望的「最長投資年期 」：',
		wt_14:'客戶的「投資目標」是怎樣呢 ?',
		wt_15:'「投資損失」有時是永久的，有時是長久的，有時是短暫的，當客戶的投資帳戶面對這些損失經驗時，客戶的反應是 :',

		wt_1_1:'A. 18 至 24',
		wt_1_2:'B. 25 至 39',
		wt_1_3:'C. 40 至 54',
		wt_1_4:'D. 55 至 64',
		wt_1_5:'E. 65 歲或以上',

		wt_2_1:'A. 不適用',
		wt_2_2:'B. 小學或以下',
		wt_2_3:'C. 中學或專上學院',
		wt_2_4:'D. 大學或以上 / 專業資格 (與財經學科相關)',
		wt_2_5:'E. 大學或以上 / 專業資格 (與財經學科無關)',

		wt_3_1:'A. 少於港幣500,000元',
		wt_3_2:'B. 港幣500,000元 至 港幣999,999元',
		wt_3_3:'C. 港幣1,000,000元 至 港幣4,999,999元',
		wt_3_4:'D. 港幣5,000,000元 至 港幣7,999,999元',
		wt_3_4_1:'E. 港幣8,000,000元或以上',
		wt_3_5:'資產種類 (可選多於1個)',
		wt_3_6:'現金及存款',
		wt_3_7:'證券',
		wt_3_8:'物業投資 (自住物業除外)',

		wt_4_1:'A. 少於港幣100,000元',
		wt_4_2:'B. 港幣100,000元 至 港幣200,000元',
		wt_4_3:'C. 港幣200,001 元 至 港幣500,000元',
		wt_4_4:'D. 港幣500,001 元 至 港幣999,999元',
		wt_4_5:'E. 港幣1,000,000元或以上',

		wt_5_1:'A. 穩定，固定 及/或 有週期性的持續收入 (備註：此收入主要從工作 / 生意 / 投資收取 )',
		wt_5_2:'B. 保留及收取穩定而固定收入',
		wt_5_3:'C. 收入並不穩定及波動',
		wt_5_4:'D. 退休、失業；但擁有儲蓄來維持',
		wt_5_5:'E. 沒有收入',

		wt_6_1:'A. 對任何於未能預測而發生的事件並沒有作特別準備',
		wt_6_2:'B. 少於6個月的家庭開支',
		wt_6_3:'C. 多於6個月但少於12個月的家庭開支',
		wt_6_4:'D. 多於12個月但少於24個月的家庭開支',
		wt_6_5:'E. 24個月或以上的家庭開支',
		wt_6_6:'(備註：這些資金或資產需為可使用和容易變賣，而且沒有罰款或只有可接受之罰款。 例如：(I) 現金、(II) 外幣、(III) 黃金 及/或 (IV) 可交易證券等)',

		wt_7_1:'A. 對投資亳無經驗',
		wt_7_2:'B. 投資經驗少於1年',
		wt_7_3:'C. 投資經驗多於1年，但少於3年',
		wt_7_4:'D. 投資經驗多於3年，但少於8年',
		wt_7_5:'E. 投資經驗多於8年',
		
		wt_8_1:'A. 少於10%',
		wt_8_2:'B. 介乎11% 至 20%',
		wt_8_3:'C. 介乎21% 至 30%',
		wt_8_4:'D. 介乎31% 至 49%',
		wt_8_5:'E. 超過 50%',
		wt_8_6:'(備註：「資產淨值」- 並不包括您的「個人自住物業」) ',

		wt_9_1:'A. 外幣存款 / 貴金屬買賣',
		wt_9_2:'B. 證券 / 股份 / 認股權證 / 交易所買賣基金 (ETFs)',
		wt_9_3:'C. 債券 (任何類型)',
		wt_9_4:'D. 互惠基金 / 單位信託 (任何類型)',
		wt_9_5:'E. 衍生性金融商品 (其包括 任何認股權證、期貨、期權、可轉讓認購權、債權股額及可轉換權利)',
		wt_9_6:'F. 定息債劵 (例如 : 政府債券、永續債券、優先證券)',
		wt_9_7:'G. 結構性 / 槓桿產品(例如 : 證券掛鉤投資、信貸掛鉤票據)',
		wt_9_8:'H. 其他 (例如 : 私募基金、對沖基金)',
		wt_9_9:'(備註：若客戶對以上任何產品類別有所認識，並於過去3年內有超過5宗或以上的交易次數，每種產品客戶可以得到1分，最高可以得到5分。)',
		wt_9_10:'經驗年期',
		wt_9_11:'經驗年期',
		wt_9_12:'過去3年交易宗數',
		wt_9_13:'過去3年交易宗數',
		wt_9_14:'(備註：若客戶對以上任何產品類別有所認識，並於過去3年內有超過5宗或以上的交易次數，每種產品客戶可以得到1分，最高可以得到5分。)',

		wt_10_1:'A. 有，請閣下註明您得到其知識的意思 (備註: 可選擇多於一項答案)',
		wt_10_2:'(I) 接受「衍生及結構性投資產品」培訓或修讀相關課程 ;',
		wt_10_3:'(II) 現時的工作 或/及 以往的工作經驗與「衍生及結構性投資產品」有關 ;',
		wt_10_4:'(III) 客戶相關投資經驗（於最近三年、最少有五次或以上之產品交易） ;',
		wt_10_4_1:'(IV) 請說明金融產品的類別：',
		wt_10_5:'B.  沒有，閣下對「衍生及結構性投資產品」完全沒有任何認識。',

		wt_11_1:'A. 「保本為主」– 本人主要目標在盡量減低投資損失，較少關注整體的回報。',
		wt_11_2:'B. 「收入主導」– 本人主要目標在獲取穩定收入或抵消通脹。',
		wt_11_3:'C. 「收入及増長」 – 本人主要目標在獲取來自資本増值及穩定收入的回報。',
		wt_11_4:'D. 「増長主導」– 本人主要目標在獲取來自以資本増值為主的回報。',
		wt_11_5:'E. 「積極增長」– 本人主要目標在獲取複雜或槓桿投資產品的較高回報。',

		wt_12_1:'A. 每年只可接受少於 5% 的波幅及潛在回報 – 本人並不預期承受投資上不穩定的波動。',
		wt_12_2:'B. 每年可接受多於 5%，但不超過10% 的波幅及潛在回報 – 本人期望獲得比銀行存款較高的回報。',
		wt_12_3:'C. 每年可接受多於 10%，但不超過 15% 的波幅及潛在回報– 本人期望獲得可以與主要證券市場相比之回報。',
		wt_12_4:'D. 每年可接受多於 15%，但不超過 25% 的波幅及潛在回報– 本人期望獲得比主要證券市場更佳的回報。',
		wt_12_5:'E. 每年可接受多於 25% 的波幅及潛在回報 – 本人的投資策略是非常進取，希望因此能達到可觀的收入。',

		wt_13_1:'A. 少於1年',
		wt_13_2:'B. 介乎多於1年，但少於3年之間',
		wt_13_3:'C. 介乎多於3年，但少於5年之間',
		wt_13_4:'D. 多於5年',

		wt_14_1:'A. 10% 或以下',
		wt_14_2:'B. 在 11% 至 20% 之間',
		wt_14_3:'C. 在 21% 至 40% 之間',
		wt_14_4:'D. 多於 41%',

		wt_15_1:'A. 若本人的投資遭受顯著惡化時，本人會將此投資立即售出。',
		wt_15_2:'B. 雖然本人的投資帳戶價值下挫令本人感到不安，但本人仍然會等候1至2個季度才會調整本人的投資組合。',
		wt_15_3:'C. 雖然本人的投資帳戶價值下挫令本人感到不安，但本人仍然會等候1至2年才會調整本人的投資組合。',
		wt_15_4:'D. 即使本人的投資帳戶價值於過去幾年遭受到顯著的下挫，但本人仍然會跟隨自己長久的投資策略及不會調整本人的投票組合。',

		pfjg:"評分結果",
		bsx:"保守型",
		wjx:"穩健型",
		jhx:"均衡型",
		zzx:"増長型",
		tqx:"進取型",
		bsx1:"「保守型」客戶的本質偏向回報較為穩定的投資產品或保存資本 及/或 在金融投資方面具備有限 / 沒有相關知識 及/或 經驗。",
		wjx1:"「穩健型」客戶的本質對於金融投資方面具有一些知識及經驗 及/或 願意承擔適度的風險、以獲取比銀行存款較高的回報。",
		jhx1:"「均衡型」客戶的本質具備有關的投資知識 及/或 經驗，願意接受相應的價格波動及承擔一定程度的風險，以獲取能與主要證券市場相約之回報，與及擁有良好的財政能力，從而應付因相關投資導致的損失。",
		zzx1:"「増長型」客戶的本質具備有關的知識 及/或 經驗，願意接受相對較高的價格波動及承擔相對較高的風險，以獲取能比主要證券市場更高的回報，與及擁有健全的財政能力，去應付因相關投資導致的損失。",
		tqx1:"「進取型」客戶對於高風險以及結構性或槓桿產品有較強的喜好、知識 及/或 經驗，與及擁有雄厚的財政能力，去應付因相關投資導致的損失。",
		khfx:'客戶風險取向',
		benren:'本人特此同意及確認所得出之結果。',
		benrenno:'本人並不同意此結果，特此確認及選擇以下之風險取向。',
		miaoshu1:'** 請選擇客戶認為最能適當描述客戶的風險取向。',
		miaoshu2:'** 請注意客戶自行選擇的風險程度只可低於現時在上方已被評估客戶之風險取向。',
		benrenyes:'本人已閱讀並同意',
		assessment:'有關風險評估之聲明條款',
		fzqx:'風險取向',
		fxqxwj:'風險承受能力問卷',


		qxzyx: "請選擇一個選項",
		fxpg: "填寫評估問卷",
		title: "本《風險承受能力問卷》旨在瞭解您的一般個人狀況，及評價您作爲投資者整體上對投資風險的一般態度。只有閣下能夠決定那種程度的風險回報能令您安心，透過本問卷可助您評價自己面對風險的承受能力。",
		q1: "Q1.您的年齡是介乎於？",
		q2: "Q2.您的教育程度是?",
		q2A: "A.小學程度或以下",
		q2B: "B.中學程度",
		q2C: "C.預科或大學程度",
		q3: "Q3.您有多少年投資於價值波動之投資產品的經驗（包括購入然後長期持有及經常買賣投資產品）？價值會波動的投資產品的例子包括股票，單位信托基金，外幣，商品，結構投資產品，認股權證（俗稱《窩輪》），期權，期貨，投資相連保單等。",
		q3A: "A.沒有經驗或少過一年",
		q3B: "B.一至三年",
		q3C: "C.多過三年",
		q4: "Q4.您是否有以下任何產品的投資經驗或知識？（您可選擇多於一個選項）",
		q4A: "A.現金，存款，存款證，保本產品，香港政府債券。",
		q4B: "B.股票，債券，股票或債券基金（包括強積金，不包括貨幣市場基金），投資相連保單。",
		q4C: "C.期權，期貨，認股權證（俗稱《窩輪》），對衝基金，其他掛鉤票據，場外交易股份。",
		q5: "Q5.在一段時間之內，投資價值可升可跌，我們稱之爲波動。一般而言，風險越高的投資，其潛在波動越大，但潛在回報亦越高。相反，風險越低的投資，其潛在波動越小，但潛在回報亦相對較低。在一般情況下，您會願意投資於波動程度多大的投資產品。",
		q5A: "A.波動多於-30%至+30%之間",
		q5B: "B.波動於-30%至+30%之間",
		q5C: "C.波動於-15%至+15%之間",
		q6: "Q6.您有多需要將投資項目變現，來滿足對突發事件的流動資金需要？",
		q6A: "A.我不一定會出售任何投資。",
		q6B: "B.我會出售不多於30%的投資。",
		q6C: "C.我會出售多於30%但少於50%的投資。",
		q6D: "D.我會出售50%以上的投資。",
		q7: "Q7.在一般情況下，投資的年期越長，承受的風險越高，而投資產品的價值亦會波動。當投資於產品時，您會願意接受下列哪項投資年期？有關投資產品的例子，請查閱問題4。",
		q7A: "A.多過三年",
		q7B: "B.一至三年",
		q7C: "C.少過一年",
		sumscore: "總分數",
		xiayibu: "下一步",
		mzsm: "免責聲明",
		nxyrzydxy: "您需要詳細閱讀並同意以下附件內的客戶協議及私隱政策。",
		mzsm1: "1.本問卷的結果是從您向華亞證券(本公司)提供的資料，並根據若干普遍接納的假設及合理估算而得出的，本問卷採用的方法及取值僅供說明",
		mzsm2: "用途，本公司對本問卷所戴資料及/或所得結果的準確性或完整性並不負責或承受任何法律責任。",
		mzsm3: "2.本問卷及所得結果僅供您參考，並非購買或出售任何金融產品及服務的要約或招攬，亦不應被視爲投資意見或推薦。",
		mzsm4: "3.請注意，倘若您未能全面披露所有或任何有關您的個人狀況(如財政狀況)，不正確，不完整或過時的資料可能影響本集團評估您對投資風險的",
		mzsm5: "態度及承受能力，如您的狀況出現變動而可能影響本問卷中任何問題的答案，我們極力建議您再次填寫本問卷。",
		fxcsnlfx: "風險承受能力分析",
		fxcscd: "風險承受程度",
		dfx: "低風險",
		zfx: "中風險",
		gfx: "高風險",
		tzzdybtz: "投資者的一般特徵",
		bsx: "保守型",
		phx: "平衡型",
		jqx: "進取型",
		fx1: "閣下願意承受低度的風險，亦明白會接受比較保守回報。",
		fx2: "閣下願意承受中度的風險，於中長綫換取潛在回報。",
		fx3: "閣下願意承受高度的風險，於長綫換取最大的潛在回報。 閣下亦明白到有可能招致損失大部份或全部本金。",
	},
	wjsc: {
		sflx: "身份類型",
		type1: "香港居民",
		type2: "國內人士",
		type3: "外國人士",
		scdzzmwj: "上載地址證明文件",
		zmwjshuoming: "請提供下列三項其中一項證明（最近三個月）並清楚顯示申請人姓名及地址，並在下方將文件上載至本公司。",
		zmwj1: "（一）信用卡或銀行卡結單",
		zmwj2: "（二）電話收費單",
		zmwj3: "（三）水/電/煤氣收費單",
		piclimit: "照片不可超過2M",
		djsctupian: "點擊選擇上載圖片",
		djzmtp: "(單據證明圖片)",
		scxgsfzzfm: "上載香港居民身份證正/背面",
		xgsfztp0: "(香港居民身份證正面圖片)",
		xgsfztp1: "(香港居民身份證背面圖片)",
		tupianmiss: "圖片走丟了",
		scsfzzfm: "上載身份證正/背面",
		sfzzm: "(身份證正面圖片)",
		sfzfm: "(身份證背面圖片)",
		scxgtxzzfm: "上載往來港澳通行證正/背面",
		xgsfzzm: "(往來港澳通行證正面圖片)",
		xiayibu: "下一步",
		xgsfzfm: "(往來港澳通行證背面圖片)",
		schz: "上載護照",
		hztp: "(護照圖片)",
		a1: "請上載地址證明圖片",
		a2: "請上載香港身份證正面圖片",
		a3: "請上載香港身份證背面圖片",
		a4: "請上載身份證正面圖片",
		a5: "請上載身份證背面圖片",
		a6: "請上載往來港澳通行證正面圖片",
		a7: "請上載往來港澳通行證背面圖片",
		a8: "請上載護照正面圖片"
	},
	ktzh: {
		yh_1:'香港上海滙豐銀行有限公司',
		yh_2:'恆生銀行有限公司',
		yh_3:'中國銀行(香港)有限公司',
		yh_4:'中國工商銀行(亞洲)有限公司',
		yh_5:'中國信託商業銀行股份有限公司香港分行',
		yh_6:'香港銀行同業結算有限公司',
		yh_title_1:'帳戶號碼 ：',
		yh_title_2:'銀行代碼 ：',
		yh_title_3:'收款戶口名稱 ：',
		yh_title_4:'銀行地址 ：',
		
		zhck:'帳戶存款',
		yhmc:'銀行名稱',
		yhdm:'銀行代碼',
		// address4_1: "香港中環花園道三號中國",
		// address4_2: "工商銀行大廈三十三樓",
		// address2_1: "香港中環金融街8號國際",
		// address2_2: "及21樓2104-10室",
		// address2_3: "及21樓2104-10室",
		qmisents1: '客戶帳號',
		hkd: '港幣',

		



		qmisent: "QMIS Securities Limited - Clients' Account",
		qmisents: '華亞證券有限公司-客戶帳號',
		hkopen: '上載文件完成',
		hkbs: '請選擇開通證券帳戶方式',
		khfs: "開戶方式",
		qtgzzfs: "請上載轉帳收據",
		qmis: "華亞證券有限公司",
		qmisclient: "華亞證券有限公司",
		type1: "郵遞開戶",
		type2: "預約時間",
		type3: "支票開戶",
		zzje: "轉帳金額",
		hdbzhb: "或同等幣值的貨幣，",
		skyh: "收款銀行",
		hfyh: "香港上海匯豐銀行有限公司",
		jsbz: "接受幣種",
		zhhm: "帳戶號碼",
		yhdz: "銀行地址",
		skyhdh: "收款銀行代號",
		skhkmc: "收款戶口名稱",
		dzhb: "多種貨幣",
		dzmy: "港幣及美元",
		address1: "香港中環皇后大道中一號",
		zsyybdfk: "（只適用於本地付款）",
		zgxtyh: "中國信託商業銀行股份有限公司香港分行",
		address2: "香港中環金融街8號國際金融中心二期28樓2801室及21樓2104-10室",
		zgyh: "中國銀行（香港）有限公司",
		gangyuan: "港幣",
		waibi: "多種貨幣",
		rmbjmy: "人民幣及美元",
		address3: "香港中環花園道一號中銀大廈",
		gyyz: "中國工商銀行(亞洲)有限公司",
		address4: "香港中環花園道三號中國工商銀行大廈三十三樓",
		sczzsj: "上載轉帳收據",
		dianjixuanzetupian: "點擊選擇上載圖片",
		zzsjtp: "(轉帳收據圖片)",
		tupianmiss: "圖片走丟了",
		qsczzsj: "請上載轉帳收據，本公司查核後，會於兩個工作天內致電閣下確認。",
		qlyyxsy: "請留意以下事項",
		sy1: "1. 只接受通過與開戶申請人之名稱相同之香港銀行帳戶進行轉帳。",
		sy2: "2. 轉帳之帳號須與提供之銀行帳號相同。",
		sy3: "3. 銀行收取的跨行轉帳及電匯費用將由客戶支付並從存款金額中扣除。",
		sy4: "4. 存入方式僅限轉帳 (網上銀行或櫃檯)，不接受現金存入等其他方式。",
		sy5: "5. 轉帳收據上必須顯示客戶名稱、客戶銀行帳號、轉帳金額及本公司之銀行帳號。",
		yyrq: "預約日期",
		yysj: "預約時間",
		zpxmzyxyq: "支票需符合以下要求",
		yq1: "1. 支票簽發人須與開戶申請人之名稱相同。",
		yq2: "2. 支票帳號須與提供之銀行帳號相同。",
		yq3: "3. 金額不得少於 港幣10,000 或 同等幣值。",
		yq4: "4. 收款人抬頭為 “華亞證券有限公司”。",
		yq5: "5. 支票上的簽名須與開戶表格上的簽名相同。",
		yq6: "6. 支票須為香港持牌銀行所發行。",
		apyjdyxdz: "請安排郵遞支票到本公司以下地址",
		dz1: "華亞證券有限公司",
		dz2: "香港上環德輔道中199號無限極廣場21樓2104室",
		dz3: "（信封面註明：客戶服務部收）",
		dz4: "華亞證券有限公司",
        dz5: "華亞證券有限公司 - 客戶帳號",
		dz6: "QMIS Securities Limited – Client Account",
		qxzyyrq: "請選擇預約日期",
		qxzyysj: "請選擇預約時間",
		qsczzsjtp: "請上載轉帳收據圖片",
		xiayibu: "完成",
		hsyh: "恒生銀行有限公司",
		address5: "香港德輔道中83號",
		ydkh1: "請依以下程序完成開戶申請 : ",
		ydkh2: "列印",
		ydkh3: "本申請文件",
		ydkh4: "在申請文件內簽署欄提供簽字式樣",
		ydkh5: "準備以下文件副本",
		ydkh6: "A.身份證 / 護照正背面",
		ydkh7: "B.最近三個月之住址證明",
		ydkh8: "C.銀行月結單",
		ydkh9: "安排見證人在申請表格及相關文件副本上填上姓名及簽署",
		ydkh10: "經以下其中一項途徑把款項發送到本公司",
		ydkh11: "A.通過銀行轉帳方式，把不少於港幣 10,000 或同等幣值之金額，轉帳到本公司收款銀行帳號，有關轉帳要求請",
		ydkh12: " ( 按此 )",
		ydkh13: "1.只接受通過與開戶申請人名稱相同的香港銀行帳號進行轉帳。",
		ydkh14: "2.轉帳的帳號要與提供之銀行帳號相同",
		ydkh15: "3.如進行跨行轉帳，銀行可能會收取相關手續費。",
		ydkh16: "4.存入方式僅限轉帳 (網上銀行或櫃台)，不接受現金存入等其他方式。",
		ydkh17: "5.轉帳收據上必須顯示客戶姓名、客戶銀行帳號、轉帳金額及本公司的銀行帳號。",
		ydkh18: "B.簽發不少於港幣 10,000 或同等幣值金額的支票，有關支票要求請",
		ydkh19: "1.支票簽發人與開戶申請人的名稱相同",
		ydkh20: "2.支票帳號與提供的銀行帳號相同",
		ydkh21: "3.金額不得少於港幣 10,000 元或同等幣值",
		ydkh22: "4.收款人為“華亞證券有限公司”",
		ydkh23: "5.支票上的簽名與開戶表格上的簽名相同",
		ydkh24: "6.支票須為香港持牌銀行所發行",
		ydkh25: "請安排把以上文件郵遞到本公司以下地址",
		warning_left: "當前可預約日期為3個月",
		warning_right: "香港公眾假期"
	},
	khfinish: {
		khwc:'開戶完成',
		success: "提交成功",
		dearuser: "親愛的客戶",
		a1:'您的開戶申請已審核通過。',
		a2:'您已開立證券帳戶，請勿重覆提交。',
		a3:'如有任何疑問，請於辦公時間內致電',
		f1: "感謝您提交開戶申請，我們會盡快與您聯絡。",
		f2: "如有任何查詢，請於辦公時間內致電：",
		f3: "客戶服務專線",
		f4: "免費內地專線",
		f5: "您已提交開戶申請。",
		f6: "如有任何査詢，請於辦公時間內致電",
		f7: "感謝您提交",
		f8: "開戶申請，我們會盡快與您聯絡。",
		t1: "感謝您提交網上開戶申請，我們會盡快與您聯絡。",
		t2: "感謝您提交預約開戶申請，我們會盡快與您聯絡。",
		t3: "感謝您提交支票開戶申請，我們會盡快與您聯絡。",
		t4: "感謝您提交郵遞開戶申請，我們會盡快與您聯絡。"
	}

};
export default tw;
